/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
import countries from '../../services/country.json'
export default {
  name: 'guest-user-list',
  components: {},
  props: [],
  data () {
    return {
      memberAllUser:null,
      memberAllUserResults:[],
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      countryList:[],
      removeUserFromOurList:false,
      removeUserId:'',
      nextPageUrl:''
    }
  },
  computed: {
  ...mapGetters([
    'getGuestUserListGetters'
  ]),
  getmemberAllUserDetailsFun(){
   this.memberAllUser = this.$store.getters.getGuestUserListGetters.data
   return 
  },
  SetIntialStatus() {
    if (this.memberAllUser) {
      this.nextStep = this.memberAllUser.next
      this.nextPageUrl = this.memberAllUser.next
      this.memberAllUserResults = this.memberAllUser
    }
  }
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getmemberAllUserDetailsFun
    this.SetIntialStatus 
  },
  methods: {
    getRemoveListAgain() {
      this.$store.dispatch('getGuestUserListFun').then((res) => {
        this.memberAllUser = res.data.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("notConnectedUserBody");
      this.removeUserFromOurList = true
      this.removeUserId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeSaOrgUserFun', {
        id: this.removeUserId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("notConnectedUserBody");
          this.removeUserFromOurList = false
          this.removeUserId = ''
          this.getRemoveListAgain()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("notConnectedUserBody");
      this.removeUserFromOurList = false
      this.taskDeleteId = ''
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.memberAllUserResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.memberAllUserResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    nextStep(old_val, new_val){
      if(new_val != ''){
        this.nextPageUrl = new_val
      }
    },
    deactivatedNextStep(old_val){
      if(old_val != ''){
        this.deactivatedPageUrl = old_val
      }
    },
    getmemberAllUserDetailsFun(){
      return  this.$store.getters.getGuestUserListGetters.data
    },
    SetIntialStatus() {
      if (this.memberAllUser) {
        this.memberAllUserResults = this.memberAllUser.results
      }
    }
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
      $("body").removeClass("notConnectedUserBody");
    next();
  },
}